var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"button-arrow btn btn-sm",class:[_vm.icon === '' ? '' : 'use-smallscreen-icon'],attrs:{"type":_vm.type}},_vm.$listeners),[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('i',{staticClass:"smallscreen-icon",class:_vm.icon}),_vm._v(" "),_c('i',{staticClass:"button-arrow-icon icon-arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/reused-components/button-arrow/ButtonArrow.vue